<template>
  <div id="ccLogin">
    <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-3 borda" style="border:10px solid #171a26; background:rgba(19,21,31,0.7); margin-top:50px; padding:50px 0 50px 0; border-radius: 15px;">

  '         <p class="text-center">
              <img :src='"../../assets/image/logo_sokker.png"' alt="Responsive image" :title='"sokkerduel"' width="180px">
            </p>

            <div class="row">
              <div class="col-md-10 offset-md-1">
                <div v-show="box_alert">
                  <br />
                  <div class="alert alert-danger alert-dismissible fade show text-center" role="alert">
                    <strong v-html="this.box_alert_text"></strong>
                  </div>
                  <br />
                </div>
              </div>
            </div>

            <section v-show="tela1">
              <div class="row">
                <div class="col-md-10 offset-md-1">

                  <div class="mt-2 mb-3 text_18 text_bold text-center" style="color: #fff;">
                    CADASTRO EM DOIS PASSOS
                  </div>

                  <div class="mt-2 mb-4 text-center" style="color: #fff;">
                    A SokkerDuel verifica a sua conta ultra rápido sem necessidade de documentação adicional.
                  </div>

                  <section v-show="step1">

                    <div v-show="buscando_informacoes" class="text-center text-success mb-3">
                      <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                      {{buscando_informacoes_texto}}
                    </div>

                    <div class="input-group mb-4">
                      <the-mask :mask="['###.###.###-##']" masked type="text" v-model="cpf_aux" class="form-control" placeholder="CPF"/>
                    </div>

                    <button type="submit" class="btn w-100 text_15 text_bold mt_5 btn-info" @click="verificar_cpf()">
                      AVANÇAR
                    </button>

                  </section>

                  <section v-show="step2">
                    <div class="input-group mb-4">
                      <input type="text" v-model="nome_completo" class="form-control disabled" placeholder="Nome Completo" disabled/>
                    </div>

                    <div class="input-group mb-4">
                      <input type="text" v-model="nascimento_aux" class="form-control disabled" placeholder="Nascimento" disabled/>
                    </div>

                    <div class="input-group mb-4">
                      <the-mask :mask="['###.###.###-##']" masked type="text" v-model="cpf" class="form-control disabled" placeholder="CPF" disabled/>
                    </div>

                    <div class="input-group mb-4">
                      <input type="text" v-model="username" class="form-control" placeholder="UserName"/>
                    </div>

                    <div class="input-group mb-4">
                      <input type="email" v-model="email" class="form-control" placeholder="E-mail" required/>
                    </div>

                    <div class="input-group mb-4">
                      <input type="email" v-model="email_aux" class="form-control" placeholder="Confirme o E-mail" required/>
                    </div>

                    <div class="input-group mb-4">
                      <input
                        type="password"
                        v-model="senha"
                        class="form-control"
                        placeholder="Senha"
                        required
                      />
                    </div>

                    <div class="input-group mb-4">
                      <input
                        type="password"
                        v-model="senha_aux"
                        class="form-control"
                        placeholder="Repetir Senha"
                        required
                      />
                    </div>

                    <div class="form-group form-check mb-4">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="check1"
                        @click="select_checkbox()"
                      />
                      <label
                        class="form-check-label"
                        for="check1"
                        style="color:#fff; text-align:justify; font-size: 12px;"
                      >
                        Ao clicar nesse botão você confirma que leu e concorda com
                        os Termos e Condições e com a Política de Privacidade de
                        empresa, além de consentir o processamento de suas
                        informações pessoais e confirmar que você é maior de idade
                        (18+).
                      </label>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <button
                          type="submit"
                          class="btn w-100 text_15 text_bold mt_5"
                          v-bind:class="[
                            btn_cadastre_se == false
                              ? 'btn-secondary disabled'
                              : 'btn-success btn_cadastre_se_on'
                          ]"
                          @click="send()">
                          CADASTRE-SE
                        </button>
                      </div>
                    </div>
                  </section>

                  <br /><br />

                  <p class="text-center">
                    <router-link to="/login" style="color: #fff;">Voltar</router-link>
                  </p>
                </div>
              </div>
            </section>


            <section v-show="tela2">
              <div class="row">
                <div class="col-10 offset-1">
                  <br/><br/>
                  <p class="text-center">
                    <router-link to="/login" style="color: #fff;">Voltar para o login</router-link>
                  </p>
                </div>
              </div>
            </section>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
var basehost = process.env.BASE_HOST;
var base_url_api = process.env.BASE_URL_API;
import axios from "axios";
import ccLoading from "../cc_geral/cc_loading.vue";
import Cookies from "js-cookie";
import { TheMask } from "vue-the-mask";

export default {
  data() {
    return {
      nome_completo: "THIAGO VIEIRA",
      cpf: null,
      cpf_aux: null,
      nascimento: "nascimento",
      nascimento_aux: null,
      username: null,
      email: null,
      email_aux: null,
      senha: null,
      senha_aux: null,
      check1: false,
      box_alert: false,
      box_alert_text: null,
      btn_cadastre_se: false,
      codigo_convite: null,
      tela1: true,
      tela2: false,
      loading: false,
      step1: true,
      step2: false,
      buscando_informacoes: false,
      buscando_informacoes_texto: "Buscando informações, aguarde...",

      timer_buscando: null,
    };
  },

  components: { TheMask, ccLoading },

  created() {

    document.title = 'Cadastro - SokkerDuel';

    this.nascimento = this.dateBR2(this.nascimento)

    localStorage.setItem("base_url_api_mobile", base_url_api);

    //let codigo = localStorage.getItem("codigo_convite")
    let codigo = Cookies.get("codigo_convite");

    if (codigo != undefined || codigo != null) {
      this.codigo_convite = codigo;
    } else {
      if (this.$route.params.link_convite != undefined) {
        Cookies.set("codigo_convite", this.$route.params.link_convite, {
          expires: 30
        });
        this.codigo_convite = this.$route.params.link_convite;
        // console.log("codigo exite 2");

        this.$router.push({ path: '/', replace: true })

      } else {
        this.codigo_convite = "cadastro_proprio";
        // console.log("cadastro proprio");
      }
    }
  },

  methods: {

    verificar_cpf() {

      //---- BUSCANDO INFORMAÇOES -----
      const textos = ["Buscando informações, aguarde...", "Mais um pouco...", "Validando informações ...", "Quase lá ...", "Ajustando informações ...", "Ajustando informações ..."];
      let index = 0;
      let timeoutId;

      const updateText = () => {
          this.buscando_informacoes_texto = textos[index];
          index++;

          if (index < textos.length) {
              const delay = index === 1 ? 4000 : 5000; // 4s após 1s, 5s após 5s, 5s após 10s, ...
              timeoutId = setTimeout(updateText, delay);
          }
      };

      timeoutId = setTimeout(updateText, 1000); // Inicia após 1 segundo
      //--------------------------------


      this.cpf = this.cpf_aux
      this.nome_completo = null
      this.nascimento = null
      this.nascimento_aux = null

      var body = {
        taxId: this.cpf.replace(/\D/g, "")
      }

      if(this.validarCPF(this.cpf) == true){

            this.box_alert = false;
            this.buscando_informacoes = true;
            
            axios.post(base_url_api + "get/persona", body)
            .then(response => {
                if (response.status == 200) {
                  if(response.data.queryResult.isUnderAge == false){
                      this.nome_completo = response.data.queryResult.fullName
                      this.nascimento = response.data.queryResult.dateOfBirth
                      this.nascimento_aux = this.dateBR2(response.data.queryResult.dateOfBirth)
                      this.step1 = false
                      this.step2 = true
                  }else{
                      this.box_alert_text = "Proibida a utilização de CPFs menores de 18 anos!";
                      this.box_alert = true;
                  }
                }

                this.buscando_informacoes = false
                clearTimeout(timeoutId);
            })
            .catch(error => {

                this.buscando_informacoes = false
                clearTimeout(timeoutId);

                if (error.response.status == 400) {
                  this.box_alert_text = error.response.data.error[0]=="person_id not found." ? "CPF não encontrado, tente novamente." : error.response.data.error[0];
                  this.box_alert = true;
                  return;
                }

                this.box_alert_text = error.message;
                this.box_alert = true;
                return;
            });

      }else{
        this.box_alert_text = "CPF inválido!";
        this.box_alert = true;
        return;
      }

    },

    async send() {

        this.box_alert = false;

        if (this.codigo_convite == null) {
          this.box_alert_text = "Convite inválido.";
          this.box_alert = true;
          return;
        }

        if (
          this.username == null ||
          this.email == null ||
          this.email_aux == null ||
          this.senha_aux == null ||
          this.codigo_convite == null
        ) {
          this.box_alert_text = "Preencha os campos obrigatórios!";
          this.box_alert = true;
          return;
        }

        if (this.username.length < 5 || this.username.length > 12) {
          this.box_alert_text = "UserName precisa ter de 5 a 12 caracteres.";
          this.box_alert = true;
          return;
        }

        if ( !this.validar_email(this.email) ) {
          this.box_alert_text = "Email inválido.";
          this.box_alert = true;
          return;
        }

        if (this.email_aux != this.email) {
          this.box_alert_text = "Confirmação de Email inválida.";
          this.box_alert = true;
          return;
        }

        if (this.senha.length < 8) {
          this.box_alert_text = "As senhas precisam ter no mínimo 8 caracteres.";
          this.box_alert = true;
          return;
        }

        if (this.senha_aux != this.senha) {
          this.box_alert_text = "Senhas não são iguais.";
          this.box_alert = true;
          return;
        }

        if (!this.check1) {
          this.box_alert_text = "Aceite os termos de compromisso!";
          this.box_alert = true;
          return;
        }

        var body = {
          nome_completo: this.nome_completo,
          nascimento: this.nascimento,
          cpf: this.cpf,
          username: this.username,
          email: this.email,
          password2: this.senha,
          codigo_convite: this.codigo_convite
        };

        this.loading = true;
        axios.post(base_url_api + "user/novo", body)
        .then(response => {
          if (response.status == 200) {
            if (response.data.status == "success") {
              this.box_alert_text = "Cadastro realizado com sucesso! <br> Verifique seu email para ativação da conta.";
              this.tela1 = false;
              this.tela2 = true;
            } else {
              console.log(response.data.data);
              this.box_alert_text = this.alerta_status_nome(response.data.data);
            }
            this.box_alert = true;
          }

          this.loading = false;
        })
        .catch(function(error) {
          if (error.message == "Request failed with status code 500") {
            this.box_alert_text = "Preencha o campo de anexo! erro 500!";
            this.box_alert = true;
          }

          if (error.message == "Request failed with status code 405") {
            alert("erro 405!");
            this.box_alert_text = "Erro 405";
            this.box_alert = true;
          } else {
            this.box_alert = true;
            this.box_alert_text = error;
          }
        });
    },

    sumir_alert() {
      this.box_alert = false;
    },

    select_checkbox() {
      if (this.check1 == true) {
        this.btn_cadastre_se = false;
      } else {
        this.btn_cadastre_se = true;
      }
    }
  } //fim do methods
};
</script>


<style scoped>

  input.form-control {
    border: none;
  }

  .disabled {
    color: #686868;
    background-color: #aeaeae;
    background-image: url("../../assets/image/cadeado.svg");
    background-size: 20px;
    background-position: right;
    background-repeat: no-repeat;
  }

</style>


// WEBPACK FOOTER //
// src/components/login/cadastro_por_convite.vue